<template>
  <div class="contact-page">
    <sub-banner>
      <template v-slot:text>
        <h1>Duo</h1>
      </template>
    </sub-banner>
    <section class="text-image" id="over-mij" style="flex-direction: row-reverse; padding-top: 100px; margin-top: -50px">
      <div class="container">
        <div class="text-side">
          <h1 class="page-title" style="font-weight: 600">Muzikaal duo met passie voor mens en muziek</h1>
          <span class="stripe"></span>
          <p>
            Wij zijn Willemien en Waisca. Samen maken we reguliere en/of christelijke muziek.
            Naast dat we allebei zingen, bespelen we verschillende instrumenten als gitaar,
            piano, percussie, mondharmonica en melodica. Op uw receptie, bruiloft of ceremonie
            zorgen wij voor akoestische achtergrondmuziek.
            <br>
            <br>
            Daarnaast kunnen we trouw- of uitvaartdiensten verzorgen. Dit kan begeleidend,
            maar ook optredend zijn.
            Als u op zoek bent naar een volledige band, die meer op de voorgrond aanwezig is
            en een feest kan verzorgen? Dat biedt ook mogelijkheden bij ons. Informeer
            vrijblijvend!
          </p>
        </div>
        <div class="img-side">
          <img alt="Willemien van Gelder Muziek Dichtbij" src="/images/duoo.webp"
               style="border-radius: 40px; max-height: 700px">
        </div>
      </div>
    </section>
    <section class="video-section">
      <div class="video-section-backdrop"></div>
      <div class="video-container container">
        <iframe allowfullscreen class="video" height="345"
                src="https://www.youtube.com/embed/hXm_cDkJnIs?si=6T8lAowNlE5VQVHp&rel=0"
                title="Vacature video"
                width="420"></iframe>
      </div>
    </section>
  </div>
</template>

<script>
import TextImage from '@/components/TextImage.vue'
import SubBanner from "@/components/SubBanner";

export default {
  name: "Verhalen",
  components: {
    SubBanner,
    TextImage
  },
  created() {
    window.scrollTo(0, 0)
  },
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="scss" scoped>

$gold: #D6AD60;

.contact-title {
  @media (max-width: 700px) {
    font-size: 25px;
    line-height: 30px;
  }
}

.video-section {
  position: relative;

  .video-section-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 130px;
    //background-color: #C99D66;
  }

  .video-headline {
    display: flex;
    align-items: center;
    padding-top: 60px;

    h4 {
      color: #C99D66;
    }

    .title-line {
      height: 3px;
      width: 100%;
      background-color: #C99D66;
    }

    .video-title {
      font-size: 44px;
      width: fit-content;
      min-width: 400px;
      @media (max-width: 500px) {
        font-size: 30px;
      }
    }
  }

  .video-container {
    position: relative;
    width: 500px;
    min-width: 60%;
    height: 600px;
    max-height: 40vw;
    display: flex;
    justify-content: center;
    margin-top: 50px;

    @media (max-width: 800px) {
      max-width: 90vw;
      height: 300px;
      max-height: unset;
    }

    .video {
      position: absolute;
      border: none;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }
  }
}

</style>
